namespace TabAurous.ECommerce {
    export namespace OrderAmazonImportService {
        export const baseUrl = 'ECommerce/OrderAmazonImport';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/OrderAmazonImport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderAmazonImportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
